import { Link } from "react-router-dom";
import { useAdminContent, AdminTitle } from "./shared";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Dashboard() {
  const { content, reload } = useAdminContent();
  if (!content) return <p className="text-clay">Loading…</p>;

  const cards = [
    { label: "Pages", value: content.pages.length, to: "/admin/pages", testid: "dash-pages-card" },
    { label: "Menu Items", value: content.menu.length, to: "/admin/menus", testid: "dash-menu-card" },
    { label: "Blog Posts", value: content.blog.length, to: "/admin/blog", testid: "dash-blog-card" },
  ];

  const discard = async () => {
    await api.post("/admin/discard");
    toast.success("Staging reset to match live");
    reload();
  };

  return (
    <div data-testid="admin-dashboard">
      <AdminTitle eyebrow="Overview" title="Dashboard" />
      {content.has_unpublished_changes && (
        <div className="mb-8 flex flex-wrap items-center justify-between gap-4 rounded-sm border border-flame/40 bg-flame/10 px-6 py-4" data-testid="unpublished-banner">
          <p className="text-sm text-sand">You have unpublished changes sitting in <span className="text-flame font-semibold">staging</span>.</p>
          <div className="flex gap-3">
            <Link to="/staging" target="_blank" data-testid="dash-preview-staging" className="rounded-full border border-brass/40 px-5 py-2 text-xs font-semibold uppercase tracking-widest text-brass hover:bg-brass/10">Preview Staging</Link>
            <button onClick={discard} data-testid="dash-discard-button" className="rounded-full border border-border px-5 py-2 text-xs uppercase tracking-widest text-clay hover:text-cream">Discard</button>
          </div>
        </div>
      )}
      <div className="grid gap-6 sm:grid-cols-3">
        {cards.map((c) => (
          <Link key={c.label} to={c.to} data-testid={c.testid} className="rounded-sm border border-brass/10 bg-card p-8 transition-colors hover:border-brass/40">
            <p className="font-serif text-5xl text-brass">{c.value}</p>
            <p className="mt-2 text-xs font-mono uppercase tracking-[0.25em] text-clay">{c.label}</p>
          </Link>
        ))}
      </div>
      <div className="mt-10 rounded-sm border border-brass/10 bg-card p-8">
        <h2 className="font-serif text-xl text-cream">How it works</h2>
        <ol className="mt-4 space-y-3 text-sm text-clay leading-relaxed list-none">
          <li><span className="font-mono text-brass">01 /</span> Edit anything — pages, sliders, menus, blog, universal header/footer — or type a request into the <span className="text-cream">AI Updater</span>.</li>
          <li><span className="font-mono text-brass">02 /</span> Every change lands in <span className="text-cream">staging</span> first. Preview it at the hidden <span className="text-cream">/staging</span> URL.</li>
          <li><span className="font-mono text-brass">03 /</span> Happy with it? Hit <span className="text-cream">Publish to Live</span> in the top bar.</li>
        </ol>
      </div>
    </div>
  );
}
